"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class UserToContact extends complexData_1.default {
    static get allowedAssociations() {
        return {
            company: {
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                key: 'company',
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().company_id,
                },
            },
            contact: {
                key: 'contact',
                instance: (0, modelLookup_1.complexFindModel)('Contact'),
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().contact_id,
                    company_id: this.Entity.getForeignFieldSymbols().company_id,
                },
            },
            //
            // This is intentionally commented out because the user is in other company
            // so the current company should not have right to access it.
            // We may want to change it later.
            //
            // user: {
            //     key: 'user',
            //     instance: User,
            //     entity: UserEntity,
            //     single: true,
            //     cascadeDelete: false,
            //     condition: {
            //         uuid: this.Entity.getForeignFieldSymbols().user_uuid,
            //     },
            // },
        };
    }
}
UserToContact.Entity = entity_1.default;
UserToContact.modelProperties = modelProperties_1.default;
exports.default = UserToContact;
//# sourceMappingURL=../../../../src/models/userToContact/index.js.map